<template>
  <div style="text-align: center" v-if="user === null">
    <v-progress-circular indeterminate />
  </div>
</template>

<script>
import { API, Auth, Hub } from "aws-amplify";
export default {
  name: "Auth",
  data: () => ({
    path:"",
    user: null,
    isAdmin: false,
  }),
  methods: {
    async afterSignIn() {
      try {
        this.user = await Auth.currentAuthenticatedUser();
        const lastRoute = localStorage.getItem('lastRoute');
        const userInfo = {
          userId: this.user.username,
          path: lastRoute,
          date: new Date()
        }
        API.post(process.env.VUE_APP_API_NAME, "/logs", {
          body: userInfo,
        })
        if (lastRoute) 
          {
            this.path = lastRoute;
            this.$router.push({ path: this.path })
            localStorage.removeItem("lastRoute")
          }
      } catch (error) {
        console.error({ func: "afterSignIn", error });
      }
    },
  },
  async beforeCreate() {
    Hub.listen("auth", async ({ payload: { event, data } }) => {
      switch (event) {
        case "signIn":
        case "cognitoHostedUI":
          await this.afterSignIn();
          break;
        case "signIn_failure":
        case "cognitoHostedUI_failure":
          console.log("Sign in failure", data);
          break;
        default:
          break;
      }
    });
    try {
      this.path = window.location.pathname
      await Auth.currentAuthenticatedUser();
    } catch {
      this.user = null;
      Auth.federatedSignIn({ provider: "login.microsoft.com" });
    }
  },
};
</script>
<style lang="scss">
.v-application {
  font-family: Arial, sans-serif;
  .title {
    font-family: Arial, sans-serif;
  }
}
</style>